import { Flex, Stack } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { switchUser } from '@lib/requests';
import { getItem, removeItem } from '@utils/localStorage';
import jwt from 'jsonwebtoken';
import router from 'next/router';

const SwitchUser = () => {
  const { localUser, setLocalUser, reFetchUser } = useAuthenticatedContextProvider();

  const handleSwitchUser = async (userId) => {
    const { token } = await switchUser(userId);
    const payload = jwt.decode(token);

    if (payload) {
      setLocalUser({
        ...localUser,
        email: payload.email,
        id: payload.userId,
        multipleUsers: payload.multipleUsers,
        role: payload.role,
        token,
        sessionId: payload.sessionId,
      });
      reFetchUser();

      // IF redirect, or query redirect exists, redirect to that page
      // Otherwise redirect to dashboard
      const localRedirect = getItem('redirect');
      const { redirect: queryRedirect } = router.query;
      const redirect = localRedirect || queryRedirect || Routes.dashboard;
      router.push(redirect);
      removeItem('redirect');
    }
  };

  const userOptions = localUser.multipleUsers.map((user) => (
    <Button whiteSpace="nowrap" type="submit" key={user.id} margin="0.5rem 0" onClick={() => handleSwitchUser(user.id)}>
      {user.first_name} {user.last_name}
    </Button>
  ));

  return (
    <DefaultLayout>
      <Stack
        alignItems="center"
        bg="darkBackground"
        border="10px solid"
        borderColor="teal"
        minHeight="90vh"
        pb={['100px', '240px', '240px', 240]}
        pt={['60px', '80px', '100px', '100px']}
        px={[10, 10, 10, 100]}
        spacing={6}
      >
        <Header as="h2">Who would you like to sign in as?</Header>
        <Body1 textAlign="center">Your email is connected to more than one account.</Body1>
        <Flex flexDirection="column">{userOptions}</Flex>
      </Stack>
    </DefaultLayout>
  );
};

export default SwitchUser;
